module.exports = __webpack_public_path__ + "img/trunk_11x1_z16.d5ac6832.svg";